// 导出一个已经配置好的axios
// 引入axios并配置
import axios from "axios";
import store from "./store";
import {Toast} from 'vant';

// 基准路径
// axios.defaults.baseURL = "http://msales-test.seedland.cc:8000";//测试
// axios.defaults.baseURL = "http://localhost:8081";//测试
// axios.defaults.baseURL = "http://192.168.64.218:8030";//预发布

axios.defaults.baseURL = "http://msales.seedland.cc:8083";//预发布
axios.defaults.timeout = 15000;
let pending = []; //声明一个数组用于存储每个ajax请求的取消函数和ajax标识
let cancelToken = axios.CancelToken;
let removePending = (ever) => {
    for (let p in pending) {
        if (pending[p].u === ever.url + '&' + ever.method) { //当当前请求在数组中存在时执行函数体
            pending[p].f(); //执行取消操作
            pending.splice(p, 1); //把这条记录从数组中移除
        }
    }
}

// 给axios配置请求拦截器
axios.interceptors.request.use(
    config => {
        // debugger
        store.state.indexUser.notice = true
        console.log(config.url,1020)
        if (config.url == axios.defaults.baseURL + '/auth/login' || config.url =='/ShortMessageServer' ) {
            config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
        } 
        else if (config.url == axios.defaults.baseURL + '/customer/submitTradingAgain') {
            const token = window.localStorage.getItem('token');
            if (token) {
                config.headers['Authorization'] = 'Bearer' + token;
            }
            config.headers['ProjectID'] = store.getters.user.projectId;
        } else {   
         if(config.url =='/teamOrg/orgjob' || config.url =='/teamOrg/addaccount' || config.url == '/teamOrg/removejobuser'){
                config.headers['Content-Type'] = 'application/json;charset=UTF-8'
            }else{
                config.headers['Content-Type'] = 'application/json;charset=UTF-8';
            }
            const token = window.localStorage.getItem('token');
            var SystemTypeNum = window.localStorage.getItem('SystemTypeNumcokie')
            
            // config.headers['Content-Type'] = 'application/json;charset=UTF-8';
            config.headers['SystemType'] = SystemTypeNum;
            config.headers['UserId'] = store.getters.user.id;
            config.headers['ProjectID'] = store.getters.user.projectId;
            config.headers['JobId'] = store.getters.user.jobID;
            config.headers['JobCode'] = store.getters.indexSystemType.JobCode;
            config.headers['projectIdInt'] = store.getters.user.projectIdInt;
            if (token) config.headers['Authorization'] = 'Bearer' + token;

        }
        removePending(config); //在一个ajax发送前执行一下取消操作
        config.cancelToken = new cancelToken((c) => {
            // 这里的ajax标识我是用请求地址&请求方式拼接的字符串，当然你可以选择其他的一些方式
            pending.push({u: config.url + '&' + config.method, f: c});
        });
    
        return config;
    },
    error => {
        store.state.indexUser.notice = false
        return Promise.reject(error);


    }
);
// response 拦截器
axios.interceptors.response.use(
    response => {

        store.state.indexUser.notice = false
        removePending(response.config);  //在一个ajax响应后再执行一下取消操作，把已经完成的请求从pending中移除
        const res = response.data;
   
        if (res.status) {
            if (res.status !== 200) {
                Toast.fail(res.message);
                // -10_0001=您的账号已在其他地方登陆！
                // -10_0002=账号不存在,请与管理员联系咨询!
                // -10_0003=非法权限,请联系咨询管理员!
                // -10_0004=您的账号当前无任何岗位,暂时无法登录,请与管理员联系咨询!
                // -10_0005=您的账号当前无任何菜单,暂时无法登录,请与管理员联系咨询!
                // -10_0006=您尚未通过审核，请与管理员联系咨询!
                // -10_0007=密码不正确,请重新输入!
                // -10_0008=您的账号已被禁用，请与管理员联系咨询!
                // -10_0009=您的账号已被删除，请与管理员联系咨询!
                // -10_0010=登录状态过期!
                // -10_0011=访问次数受限制!
                // -10_0012=参数格式不正确！
                // -10_0013=Token解析失败！
                // -10_0014=无权限访问,请联系咨询管理员!
                if (res.status === '-10_0006' || res.status === '-10_0008' || res.status === '-10_0009' || res.status === '-10_0010' || res.status === '-10_0013') {
                    store.dispatch('FedLogOut').then(() => {
                        location.reload() // 为了重新实例化vue-router对象 避免bug
                    });
                } else if (res.status == '-100003' || res.status == '-100001') {
                    localStorage.removeItem("userInfo");
                    localStorage.removeItem("SystemTypeNumcokie");
                    localStorage.removeItem("customparams");
                    localStorage.removeItem("token");
                    localStorage.removeItem("user");
                    window.location.replace('/#/Login')
                }
                return Promise.reject('error')
            } else {
                return Promise.resolve(res.data);
            }
        } else {
            if (response.status !== 200) {
                // Toast.fail("登陆失败");
                return Promise.reject('error')
            } else {
                return res.data ? Promise.resolve(res.data) : Promise.resolve(res);
            }
        }

    },
    error => {
        if (error.message == undefined) {
            throw '不要慌'
         }
        else if (error.message == 'timeout of 15000ms exceeded') {
            Toast.fail('网络超时')
        } else if (error.message == 'Network Error') {
            Toast.fail('网络异常')
        }
         else {
            Toast.fail(error.message)
        }
        store.state.indexUser.notice = false

        return Promise.reject(error)
    }
);

export default axios;
